import React from 'react';

const KallistaLogo = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "20", viewBox: "0 0 120 20", fill: "none", "aria-label": "Kallista Logo" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.0913V1.42895H1.56745V9.70491L9.47533 1.42895H11.5541L3.26383 9.87454L11.9481 19.0913H9.64267L1.56745 10.1274V19.0913H0Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7169 19.0913L20.0385 12.974H27.1958L29.4334 19.0913H31.1688L23.7966 0.389999L16.1038 19.0913H17.7169ZM23.6892 3.76242L26.6812 11.5762H20.577L23.6892 3.76242Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3636 19.6108V0.909476H37.9742V18.0219H44.1558V19.6108H36.3636Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3506 19.6108V0.909476H50.9615V18.0219H57.1428V19.6108H49.3506Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M64.9352 19.0913H66.4936V1.42895H64.9352V19.0913Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2856 16.0683L75.6446 15.305C75.896 16.2068 76.3294 16.9053 76.9471 17.4018C77.5631 17.8982 78.3028 18.146 79.1678 18.146C80.2592 18.146 81.1113 17.8039 81.724 17.1202C82.3368 16.4362 82.6433 15.4904 82.6433 14.2805C82.6433 13.3971 82.438 12.6623 82.0256 12.0782C81.6134 11.4942 80.728 10.8187 79.3691 10.0515C77.6317 9.07567 76.4756 8.21654 75.9025 7.47374C75.3285 6.73159 75.0415 5.83906 75.0415 4.79548C75.0415 3.49464 75.4571 2.43462 76.289 1.61687C77.1208 0.799281 78.1993 0.389999 79.5251 0.389999C80.3926 0.389999 81.1476 0.583561 81.7903 0.970196C82.433 1.35634 82.9553 1.93523 83.3572 2.70802L82.1128 3.49758C81.8614 2.96349 81.5067 2.55519 81.0474 2.27527C80.5882 1.99503 80.044 1.85491 79.4167 1.85491C78.5687 1.85491 77.8936 2.12114 77.3907 2.65246C76.888 3.18491 76.6374 3.90262 76.6374 4.80689C76.6374 6.09632 77.6342 7.29729 79.6285 8.41141C79.9899 8.61263 80.264 8.76806 80.4531 8.87576C81.9277 9.73326 82.9132 10.5432 83.4096 11.3046C83.9068 12.0658 84.1558 13.0535 84.1558 14.2681C84.1558 15.9078 83.7015 17.2082 82.7961 18.17C81.889 19.1303 80.656 19.6108 79.0967 19.6108C77.9608 19.6108 76.9898 19.3149 76.1831 18.7222C75.3745 18.1302 74.7424 17.2458 74.2856 16.0683Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2426 19.0913V2.9296H89.3508V1.42895H100.779V2.9296H95.8441V19.0913H94.2426Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.432 19.0913L105.753 12.974H112.91L115.148 19.0913H116.883L109.511 0.389999L101.818 19.0913H103.432ZM109.404 3.76242L112.396 11.5762H106.292L109.404 3.76242Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.747 17.9782V17.6071H118.991C119.115 17.6071 119.249 17.6346 119.249 17.783C119.249 17.967 119.113 17.9782 118.961 17.9782H118.747ZM118.747 18.1322H118.953L119.265 18.6514H119.465L119.129 18.1239C119.302 18.102 119.436 18.0085 119.436 17.7941C119.436 17.5575 119.297 17.4533 119.018 17.4533H118.568V18.6514H118.747V18.1322ZM118.963 19.0913C119.522 19.0913 120 18.6514 120 18.0499C120 17.4533 119.522 17.0134 118.963 17.0134C118.399 17.0134 117.922 17.4533 117.922 18.0499C117.922 18.6514 118.399 19.0913 118.963 19.0913ZM118.129 18.0499C118.129 17.5575 118.494 17.1867 118.963 17.1867C119.427 17.1867 119.794 17.5575 119.794 18.0499C119.794 18.5499 119.427 18.9183 118.963 18.9183C118.494 18.9183 118.129 18.5499 118.129 18.0499Z",
    fill: "currentColor"
  }
));

export { KallistaLogo };
